import { IApplicationState } from '../../types/redux';

export function selectResultsSortedOfferIds(state: IApplicationState) {
  return state.results.sortedOfferIds;
}
